import { routes } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'
import CircleLoader from 'shared-components/CircleLoader'
import { Input, Modal } from 'ui-framework'
import LendFormBis from './LendForm/LendForm'
import LendList from './LendList'
import LendVM from './LendVM'
import UserYields from './UserYields'

function Lend({ vm }: { vm: LendVM }) {
  const userYields = vm.lendStore.userYields.value
  return (
    <div className="lend-page">
      <main>
        <div className="lend__top-container margin-bottom-1">
          <div className="txt-center btn--sticked-horizontal">
            <NavLink to={routes.lendAsset} className="btn btn--tab-blue btn--medium">
              Lend
            </NavLink>
            <NavLink to={routes.lendYields} className="btn btn--tab-blue btn--medium">
              <div className="flex-center">
                Your Yields
                <div className="btn--tab__number margin-left-1">
                  {vm.fetchingData ? (
                    <CircleLoader>{userYields.length}</CircleLoader>
                  ) : (
                    userYields.length
                  )}
                </div>
              </div>
            </NavLink>
          </div>
          <Input
            id="lend-input"
            className="borrow--search-input"
            placeholder="ETH, OOKI, ..."
            onChange={vm.set}
            onChangeEmit="name-value"
            name="searchQuery"
            value={vm.searchQuery}
            icon="search"
          />
        </div>

        <Switch>
          <Route path={routes.lendAsset} render={() => <LendList vm={vm} />} />
          <Route path={routes.lendYields} render={() => <UserYields vm={vm} />} />
          <Route path="*" render={() => <Redirect to="/lend/asset" />} />
        </Switch>

        <Modal
          isOpen={vm.lendDialog.visible}
          onRequestClose={vm.lendDialog.hide}
          onAfterClose={vm.lendDialog.hide}>
          <LendFormBis vm={vm} />
        </Modal>
      </main>
    </div>
  )
}

export default observer(Lend)
